module.exports = new __parcel__URL__("Paladinskill_34.7feff019.png").toString();